package com.essntl.features.country.ui.addeditcountry

import com.essntl.features.country.domain.model.CountryModel

sealed interface AddEditCountryEvent {
    data class GetCountry(val id: String) : AddEditCountryEvent
    data class UpdateCountryFields(val country: CountryModel) : AddEditCountryEvent
    data object AddCountry : AddEditCountryEvent
    data object EditCountry : AddEditCountryEvent
    data object DeleteCountry : AddEditCountryEvent
    data object ClearState : AddEditCountryEvent
}